import React, { useState, useEffect, useRef } from "react";
import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import useOutsideAlerter from "functions/useOutsideAlerter";
import useScrollPosition from "functions/useScrollPosition";

import { getRouteName } from "functions/getMeta";

import routes from "configs/routes";

import NavbarItem from "components/Navigation/NavbarItem";
import NavToggle from "./NavToggle";

import auth from "functions/auth";

import logo_coloured from 'assets/images/csango10-logo-color-1.svg';
import logo_transparent from 'assets/images/csango10-logo-transparent-1.svg';
import clg from "functions/log";

//főoldal, lakások, fizetés, dokumentumok, galéria, kapcsolat

const Navbar = ({footerRef, introductionRef, newsletterRef}) => {

    const location = useLocation();
    const menuRef = useRef(null);
    const mobileMenuRef = useRef(null);

    const [mobileMenuState, setMobileMenuState] = useState(false);
    const [navbarBackgroundState, setNavbarBackgroundState] = useState(true); //true > transparent, false > has background

    useOutsideAlerter(menuRef, hideMobileMenu);
    const scrollPosition = useScrollPosition();

    useEffect(()=>{
        //Az adminon belül ne legyen transparent a Navbar
        if( location.pathname.includes( routes.admin + "/" ) || location.pathname.includes( routes.blogListings + "/" ) ) {
            setNavbarBackgroundState(false);
            return;
        }

        if( scrollPosition.y >= 130 ) setNavbarBackgroundState(false);
        else setNavbarBackgroundState(true);
    },[scrollPosition])


    const navbarItems = [
        {
            to : routes.index,
            //title : "Főoldal",
            title : getRouteName(routes.index),
        },
        {
            to : routes.apartments,
           // title : "Lakások",
            title : getRouteName(routes.apartments),
        },
        {
            to : routes.introduction,
            toRef : introductionRef,
            redirectIfNotOn : routes.index,
            //title : "Bemutatkozás"
            title : getRouteName(routes.introduction),
        },
        {
            to : routes.gallery,
            //title : "Galéria",
            title : getRouteName(routes.gallery)
        },
        {
            to : routes.paymentInformations,
            //title : "Értékesítés",
            title : getRouteName(routes.paymentInformations)
        },
        /* {
            to : routes.documents,
            title : routes.helmet.documents.title,
        }, */
        {
            to : routes.blogListings,
           // title : "Hírek",
            title : getRouteName(routes.blogListings)
        },
        {
            to : routes.contact.replace("/",""),
            toRef : footerRef,
            //title : "Kapcsolat",
            title : getRouteName(routes.contact),
            highlighted : true,
        },
    ];

    const menuVariants = {
        open: {
            display : "flex",
            opacity: 1,
            top : 0,
            transition:{
                duration: 0.3,
            },
        },
        close: {
            opacity: 0,
            top: "-100%",
            zIndex: -1,
            transition:{
                duration: 0.3,
            },
            transitionEnd : {
                display : "none",
            }
        },
    };

    const navBackgroundVariants = {
        transparent : {
            boxShadow: "0px 30px 60px 109px rgba(255 255 255 0) inset, 0 15px 30px -15px rgba(0,0,0,0)",
            transition:{
                duration : 0.3
            }
        },
        hasBackground : {
            opacity:1,
            boxShadow: "0px 30px 60px 109px rgba(255 255 255 1) inset, 0 15px 30px -15px rgba(0,0,0, 0.3)",
            transition:{
                duration : 0.3
            }
        }
    }

    function hideMobileMenu() {
        setMobileMenuState( false );
    }

    return (
        <>
        
        <nav className="site-nav">
            <div className="container">

                <motion.div className={"menu-bg-wrap" + ( navbarBackgroundState ? " transparent" : " hasBackground" )}
                    variants={ navBackgroundVariants }
                    initial="transparent"
                    animate={ navbarBackgroundState ? "transparent" : "hasBackground" }
                    ref={menuRef}
                >

                <div className="site-logo">
                    <Link to={ routes.index } onClick={ () => hideMobileMenu() }>
                        <img src={ ( navbarBackgroundState ? logo_transparent : logo_coloured ) } alt="Csángó 10 logo"/>
                    </Link>
                </div>

                    <div className="site-navigation">

                        <ul className="site-menu">
                             
                            <>
                            {
                                navbarItems.map((value,key) => (
                                    (value.hasOwnProperty("to") && value.to && value.hasOwnProperty("title") && value.title ) && (
                                        <NavbarItem to={ value.to } redirectIfNotOn={ value.redirectIfNotOn ? value.redirectIfNotOn : null } toRef={ value.toRef ? value.toRef : null } title={ value.title } key={ "menu-item-" + key } highlighted={ ( value.highlighted ? value.highlighted : false ) }
                                        onClick={ (e) => {

                                            if(typeof value.onClick === "function") {
                                                value.onClick(e);
                                            }


                                            hideMobileMenu();
                                        }}/> 
                                    )
                                ))
                            }
                            {
                                auth.isAuthenticated() && (
                                    <>
                                    <NavbarItem to={routes.dashboard} title={<i className="fas fa-user-shield"></i>} className="admin" onClick={ hideMobileMenu }/>
                                    <NavbarItem to="#" title={<i className="fas fa-sign-out-alt"></i>} className="logout" onClick={ () => auth.logout() }/>
                                    </>
                                )
                            }
                            </>
                        </ul>

                        <motion.div className="site-mobile-menu" variants={ menuVariants } initial="close" animate={ (mobileMenuState ? "open" : "close") } >
                            <ul className="mobile" ref={mobileMenuRef}>
                                <>
                                {
                                    navbarItems.map((value,key) => (
                                        (value.hasOwnProperty("to") && value.hasOwnProperty("title")) && (
                                            <NavbarItem to={ value.to } redirectIfNotOn={ value.redirectIfNotOn ? value.redirectIfNotOn : null } toRef={ value.toRef ? value.toRef : null } title={ value.title } key={ "menu-item-" + key } highlighted={ ( value.highlighted ? value.highlighted : false ) }
                                            onClick={ (e) => {

                                                if(typeof value.onClick === "function") {
                                                    value.onClick(e);
                                                }
    
    
                                                hideMobileMenu();
                                            }}/> 
                                        )
                                    ))
                                }
                                {
                                    auth.isAuthenticated() && (
                                        <>
                                        <NavbarItem to={routes.dashboard} title={<><i className="fas fa-user-shield"></i>Admin felület</>} className="admin" onClick={ hideMobileMenu }/>
                                        <NavbarItem to="#" title={<><i className="fas fa-sign-out-alt"></i>Kijelentkezés</>} className="logout" onClick={ () => auth.logout() }/>
                                        </>
                                    )
                                }
                                </>
                            </ul>
                        </motion.div>

                        <NavToggle
                            isOpen={mobileMenuState}
                            onClick={() => setMobileMenuState(!mobileMenuState)}
                            strokeWidth="3"
                            color={ navbarBackgroundState ? "#fff" : "#000" }
                            lineProps={{ strokeLinecap: "round" }}
                            transition={{ type: "spring", stiffness: 260, damping: 20 }}
                            width="24"
                            height="20"
                            //style={menuButtonStyle}
                        />

                    </div>

                </motion.div>
            </div>

            {/* !location.pathname.includes(routes.blogSingle.replace(":slug",  "")) && !location.pathname.includes(routes.apartment.replace(":id",  "")) && scrollPosition.y < 1 && !mobileMenuState &&  (
            <div className={"nav-alert"}>Személyes találkozó előtt időpontegyeztetés szükséges!</div>
            ) */}

        </nav>

        </>
    )
}

export default Navbar;